/* eslint-disable prefer-destructuring */
import moment from 'moment-timezone';

export const hasObjectKeys = (object = {}) => !!Object.keys(object).length;

export const hasArrayElements = (array = []) => !!array.length;

export const hasArrayJustOneElement = (array = []) => array.length === 1;

export const returnElementAppearingOnceInArray = (array = []) => {
  let lookedItem = array[0];
  if (array.length !== 1) {
    for (let i = 0; i < array.length; i += 1) {
      for (let j = 0; j < array.length; j += 1) {
        if (lookedItem === array[j] && i !== j) {
          lookedItem = false;
          break;
        }
      }
      if (lookedItem !== false) {
        break;
      }
      if (i !== array.length - 1 && lookedItem === false) {
        lookedItem = array[i + 1];
      }
    }
  }

  return lookedItem;
};

export const parseDate = (date, timezone) => {
  // divided by -60, because func utcOffset returns timezones offset from UTC in minutes and with the opposite sign (+2hours is -120)
  const timeVariableParser = -60;
  const offset =
    moment?.tz.zone(timezone)?.utcOffset(new Date(date).getTime()) /
    timeVariableParser;
  const newLocalDate = new Date(date);
  newLocalDate.setHours(newLocalDate.getHours() + offset);

  const parsedDate = new Date(newLocalDate)
    .toLocaleString('en-GB')
    .split(' ')[0]
    .split(',')[0]
    .split('/')
    .join('-');
  const parsedTime = new Date(newLocalDate)
    .toTimeString()
    .split(' ')[0]
    .split(':');

  const localTime = `${parsedDate !== 'Invalid' ? parsedDate : '-'} ${
    parsedTime[0] !== 'Invalid' ? `${parsedTime[0]}` : ''
  }${parsedTime[1] !== undefined ? `:${parsedTime[1]}` : ''}
    [${timezone}]`;
  return localTime;
};

export const getGeometryOfFeature = featureGeometry => {
  if (featureGeometry.length) return featureGeometry;
  if (featureGeometry.features?.length) {
    if (featureGeometry.features[0].geometry.coordinates.length)
      return featureGeometry.features[0].geometry;
  }

  return null;
};

export const convertFeetToMeters = (height, reverse = false) => {
  if (!reverse) return Math.round(height * 0.3048 * 100) / 100;
  return Math.round(height * 3.2808399 * 100) / 100;
};
